<check-in-default-modal #changeFlightsWarningModal modalId="changeFlightsModalId"
  modalTitle="{{'You will lose your selections' | translate: 'extras'}}"
  modalText="{{'Are you sure you want to continue? You will lose all previous selections!' | translate: 'extras'}}"
  okButtonText="{{'Ok' | translate: 'extras'}}"
  cancelButtonText="{{'Cancel' | translate: 'extras'}}"
  [okRequired]="true" [cancelRequired]="true">
</check-in-default-modal>
